import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { InventoryProvider } from './contexts/InventoryContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Login from './components/auth/Login';
import Dashboard from './components/dashboard/Dashboard';
import ProductCatalog from './components/products/ProductCatalog';
import ProductDetail from './components/products/ProductDetail';
import ScannerMode from './components/scanner/ScannerMode';
import InventoryHistory from './components/inventory/InventoryHistory';
import UserManagement from './components/users/UserManagement';
import SalesReport from './components/reports/SalesReport';
import SalesListingReport from './components/sales/SalesListingReport';
import PalletManager from './components/pallets/PalletManager';
import PalletReport from './components/pallets/PalletReport'; 
import Layout from './components/layout/Layout';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, loading, initialized } = useAuth();

  if (!initialized || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-300">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function AppRoutes() {
  const { user, initialized, loading } = useAuth();

  if (!initialized || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-300">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="products" element={<ProductCatalog />} />
        <Route path="products/:id" element={<ProductDetail />} />
        <Route path="pallets" element={<PalletManager />} />
        <Route path="pallets/report" element={<PalletReport />} />
        <Route path="sales-listings" element={<SalesListingReport />} />
        <Route path="scanner" element={<ScannerMode />} />
        <Route path="sales-report" element={<SalesReport />} />
        <Route path="history" element={<InventoryHistory />} />
        <Route path="users" element={<UserManagement />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <InventoryProvider>
          <Router>
            <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
              <AppRoutes />
              <Toaster 
                position="top-right"
                toastOptions={{
                  duration: 3000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                }}
              />
            </div>
          </Router>
        </InventoryProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;